// @flow

import React, { PureComponent } from 'react';
import { Field } from 'redux-form';

import type { ComponentType } from 'react';

const requiredFieldValidator = val =>
  (val === null || val === undefined || val === ''
    ? { path: 'common.form.error.required' }
    : undefined);

type Props = {
  component: ComponentType<*> | Function | string,
  name: string,
  validate: Array<Function>,
};

class RequiredField extends PureComponent<Props> {
  static defaultProps = {
    validate: [],
  };

  render() {
    const { component, name, validate, ...otherProps } = this.props;

    return (
      <Field
        {...otherProps}
        isRequired
        name={name}
        component={component}
        validate={[requiredFieldValidator].concat(validate)} />
    );
  }
}

export default RequiredField;
